export const green = '#51cf66';
export const black = '#212529';
export const white = '#f8f9fa';
export const lightgray = '#f1f3f5';
export const blue = '#4990e2';
export const darkBlue = '#7a67e2';
